import { useQuery } from "@tanstack/react-query";

import { getNocCodes } from "../../services/jobs";

import { INocCode } from "../../interfaces/services";

const useGetNocCodes = () => {

    const queryFn = async (): Promise<INocCode[]> => {
        return await getNocCodes();
    };

    return useQuery({
        queryKey: ['noc_codes'],
        queryFn,
        retry: 0,
    });
};

export default useGetNocCodes;